var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BABABD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,30c0,16.6-13.4,30-30,30S0,46.6,0,30C0,13.4,13.4,0,30,0S60,13.4,60,30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,38.7v1.7c0,1.6-1.3,2.8-2.8,2.8H13.9c-1.6,0-2.8-1.3-2.8-2.8v-1.7c0-3.8,3.1-6.8,6.8-6.8h0.5 c1.2,0.6,2.6,0.9,4.1,0.9c1.5,0,2.8-0.4,4.1-0.9H27C30.7,31.9,33.8,35,33.8,38.7z M15.8,23.4c0-3.7,3-6.6,6.6-6.6s6.6,3,6.6,6.6 s-3,6.6-6.6,6.6S15.8,27,15.8,23.4z M49,38.5c0,1.6-1.3,2.8-2.8,2.8H35.7c0-0.1,0-0.2,0-0.4v-2.3c0-2.3-0.9-4.4-2.4-5.9 c1-0.6,2.1-0.9,3.3-0.9h0.2c0.8,0.3,1.7,0.5,2.6,0.5s1.8-0.2,2.6-0.5h0.2C46,31.9,49,34.9,49,38.5z M33.8,24.3 c0-3.1,2.5-5.7,5.7-5.7s5.7,2.5,5.7,5.7S42.6,30,39.5,30S33.8,27.5,33.8,24.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUserIcon);
export default __webpack_public_path__ + "static/media/multi-user-icon.e7cdc3d9c4f3e7eacb9f53743793fd6a.svg";
export { ForwardRef as ReactComponent };